import StudentsDetailsPage from './StudentsDetailsPage';
export default StudentsDetailsPage;
